// extracted by mini-css-extract-plugin
export default {"form-control-text-area":"FormControlTextArea_form-control-text-area__dx4HQ","feedback":"FormControlTextArea_feedback__mr8R+"};